import React from 'react';

const SearchHeader = ({ searchQuery, setSearchQuery, onSearch }) => {
  return (
    <div className="mb-10">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
        <div>
          <h1 className="text-5xl font-bold text-gray-900 mb-2">بحث قطع غيار السيارات</h1>
          <p className="text-gray-600 text-lg text-2xl">ابحث عن قطع الغيار الأصلية لسيارتك بكل سهولة وسرعة</p>
        </div>
        <div className="mt-4 md:mt-0 flex items-center space-x-4">
          <div className="bg-gradient-to-r text-xl from-green-600 to-green-700 text-white px-4 py-2 rounded-lg font-semibold">
            <span className="text-yellow-300 text-xl">★</span> قطع أصلية 100%
          </div>
          <div className="bg-white text-gray-800 px-4 py-2 text-xl rounded-lg font-semibold shadow-md">
            شحن سريع
          </div>
        </div>
      </div>
      
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-green-400 to-green-600 rounded-2xl shadow-xl transform rotate-1"></div>
        <div className="relative bg-white rounded-2xl shadow-2xl p-6">
          <div className="flex flex-col md:flex-row md:items-center">
            <div className="md:w-2/3 mb-6 md:mb-0 md:pr-6">
              <h2 className="text-3xl font-bold text-gray-800 mb-2">كيف تبحث عن قطع غيار سيارتك؟</h2>
              <p className="text-gray-600 text-2xl ">استخدم البحث العام، تصفح الفئات، أو ابحث باستخدام مواصفات سيارتك المحددة</p>
            </div>
            <div className="md:w-1/3">
              <div className="relative">
                <input
                  type="text"
                  className="w-full p-4 pr-12 text-2xl border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent text-gray-800"
                  placeholder="ابحث برقم القطعة..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && onSearch()}
                />
                <button 
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-green-600"
                  onClick={onSearch}
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchHeader;